module.exports = __webpack_public_path__ + "static/media/Hover5_Boulder.b58eba75.jpg";